<ng-container *ngIf="!isBdOnly" [caLocalizationScope]="localizationScope">
  <i
    class="f-i"
    [class]="getIconClass()"
    [ngClass]="[iconClass, iconSizeClass]"
    [ngbTooltip]="tooltipContent"
    [container]="container"
    data-automation-id="bd-crm-profiles-icon"
  >
  </i>
  <ng-template #tooltipContent>
    <span>{{ getIconTitle() | caLocalize }}</span>
  </ng-template>
</ng-container>
